/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
import React from 'react';
import Layout from '../../src/components/Layout/Layout';
import { ABOUT_US_PAGE } from '../../lib/queries';
import client from '../../lib/apolloClient';
import Technological from '../../src/components/AboutUs/Technological/Technological';
import Mangement from '../../src/components/AboutUs/Management/Management';
import MissonVisionValues from '../../src/components/AboutUs/MissonVisionValues/MissonVisionValues';
import Overview from '../../src/components/AboutUs/Overview/Overview';
import Sustainability from '../../src/components/AboutUs/Sustainability/Sustainability';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';
import IsoCertification from '../../src/components/AboutUs/ISOCertification/IsoCertification';

const AboutUs = (props) => {
  const { data } = props;

  return (
    <Layout>
      <Overview data={data.aboutUs} />
      <MissonVisionValues data={data.aboutUs} />
      <Sustainability data={data.aboutUs} />
      <IsoCertification data={data.aboutUs} />
      <Technological data={data.aboutUs} />
      <Mangement data={data.aboutUs} />
    </Layout>
  );
};

export default AboutUs;

export async function getServerSideProps() {
  let { data } = await client.query({ query: ABOUT_US_PAGE });
  data = await replacePictureUrlWithSignedUrl(data);
  return {
    props: { data },
  };
}
